module.exports = __webpack_public_path__ + "static/media/coffee.4af5b04c.svg";